// components/SummaryCard.js
import React from "react";

const gradientBackgrounds = {
  primary: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
  secondary: "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
  info: "linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)",
};

const SummaryCard = ({ title, value, colors = [], variant = "primary", details = [] }) => {
    return (
      <div
        style={{
          borderRadius: "12px",
          padding: "20px 22px",
          width: "240px",
          minHeight: "110px",
          boxShadow: "0 6px 18px rgba(0, 0, 0, 0.08)",
          background: gradientBackgrounds[variant],
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <h4 style={{ fontSize: "16px", fontWeight: 500, marginBottom: "8px" }}>{title}</h4>
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>{value}</div>
  
        {colors.length > 0 && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              marginTop: "10px",
            }}
          >
            {colors.map((color, idx) => (
              <span
                key={idx}
                style={{
                  padding: "6px 12px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: 500,
                  backgroundColor: "#ffffff",
                  color: "#333333",
                  border: "1px solid #dddddd",
                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                }}
              >
                {color}
              </span>
            ))}
          </div>
        )}
  
        {details.length > 0 && (
          <div style={{ marginTop: "12px" }}>
            {details.map((d, i) => (
              <div key={i} style={{ fontSize: "14px", fontWeight: 500 }}>
                {d.label}: <span style={{ fontWeight: 600 }}>{d.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
  

export default SummaryCard;
